// @ts-expect-error React import required to render in Jira SSR
import React from 'react';
import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import { type CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--jira-werewolves/admin-agent-recommendation';

import { TriageAgentRecommendationBanner } from '../../../components/TriageAgentRecommendationBanner';

import type { TriageAgentRecommendation } from '../../../triage-agent-recommendation';

type RenderProps = TriageAgentRecommendation & PlacementRenderProps;

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<RenderProps>(),
		Component: ({
			dismiss,
			projects,
			agentId,
			agentAri,
			agentKey,
			onSetUp,
			onLearnMore,
		}: RenderProps) => (
			<TriageAgentRecommendationBanner
				dismiss={dismiss}
				projects={projects}
				agentId={agentId}
				agentAri={agentAri}
				agentKey={agentKey}
				onSetUp={onSetUp}
				onLearnMore={onLearnMore}
			/>
		),
	},
});
